//from Node
require('js.cookie');
require('bootstrap-datepicker');
require('swiper');

//from local
require('./radio');
require('../common/password-strength');
require('../common/countdown');
require('./base');
require('./swiper-setup');
require('./taketime');
require('./cookie-banner')
// Enter the JS for your build here
require('./custom');
